import { Form } from 'antd';
import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const StyledForm = styled(Form)`
  input[type='file'] {
    position: absolute;
    margin: -1px;
    width: 1px;
    height: 1px;
    border: 0;
    clip: rect(0, 0, 0, 0);
    overflow: hidden;
  }

  label {
    cursor: pointer;

    ${({ theme }) =>
      theme.themeName === Theme.Dark &&
      `
      color: ${theme.contrastColor};
    `}
  }
`;

export const DragAndDropContainer = styled.div`
  input[type='file'] {
    display: none;
  }

  &.active {
    background: ${({ theme }) => theme.tealLightOpacity};
    border: 3px dashed ${({ theme }) => theme.teal};
    border-radius: 8px;
  }
`;
